// Save as NPC (issue 1157): a name and a note saved to the campaign's NPC pool on the site (issue 1056's pool, the note
// being the site's notes for that NPC, the DM's alone). Opened from a quick NPC's card and from any table line in the DM's
// log, prefilled; the DM may change either before saving. Nothing reaches the table.
import { useState } from 'react';
import { Modal } from '../Dialogs';
import { useShell } from '../context';
import { saveNpc } from '../../npcs';
import { useOptionalTableState } from '../../table/TableState';
import { BTN } from '../ui';

const btn = BTN;

export function SaveNpcDialog({ name: first, note: firstNote = '', onClose, onSaved }: { name: string; note?: string; onClose: () => void; onSaved?: (name: string) => void }) {
  const { campaignId } = useShell();
  const table = useOptionalTableState();
  const [name, setName] = useState(first.slice(0, 200));
  const [note, setNote] = useState(firstNote.slice(0, 2000));
  const [said, setSaid] = useState('');
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!name.trim()) { setSaid('The NPC needs a name.'); return; }
    setBusy(true);
    const got = await saveNpc(campaignId, { name, note });
    setBusy(false);
    // Said in the table's passing notice, wherever the dialog was opened from: closing alone looked like nothing happened.
    if (got.kind === 'ok') { table?.setNotice(`Saved ${got.name} to the campaign's NPCs.`); onSaved?.(got.name); onClose(); } else setSaid(got.kind === 'refused' ? got.reason : "The site can't be reached just now. Try again in a moment.");
  };
  return (
    <Modal title="Save as NPC" onClose={onClose} testId="save-npc">
      <form className="space-y-2 text-sm" onSubmit={(e) => { e.preventDefault(); if (!busy) void save(); }}>
        <label className="block text-stone-300">Name
          <input data-testid="save-npc-name" className="mt-1 w-full rounded bg-stone-800 px-2 py-1" maxLength={200} value={name} onChange={(e) => { setName(e.target.value); setSaid(''); }} />
        </label>
        <label className="block text-stone-300">Note (kept with the NPC on the site, yours alone)
          <textarea data-testid="save-npc-note" className="mt-1 w-full rounded bg-stone-800 px-2 py-1" rows={3} maxLength={2000} value={note} onChange={(e) => setNote(e.target.value)} />
        </label>
        <p className="text-xs text-stone-500">Saved to the campaign's NPCs; the players are told nothing.</p>
        {said && <p role="alert" className="text-xs text-amber-300" data-testid="save-npc-said">{said}</p>}
        <div className="flex justify-end gap-1">
          <button type="button" className={btn} onClick={onClose}>Cancel</button>
          <button type="submit" className={btn} disabled={busy} data-testid="save-npc-save">Save to the campaign</button>
        </div>
      </form>
    </Modal>
  );
}
